import React from 'react';

import ProviderFactory from '../common/components/provider';
import SignUp from './components/sign-up';

export default ProviderFactory(<SignUp />);
